<ng-template #errorToast>
  <div class="d-flex align-items-center gap-4x">
    <p>{{ 'api.errors.500' | translate }}</p>
    <button
      ds-button
      variant="ghost-muted"
      icon="file_copy"
      (click)="copy()"
    ></button>
  </div>
</ng-template>
